module.exports = __webpack_public_path__ + "static/photo11-afd8a6c4baad95386d7d1a7eaf9b757c.jpg";